/**
 * Formátovanie dátumu pre zobrazenie
 */

export function formatListingDate(dateString: string): string {
  try {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffMinutes = Math.floor(diffMs / (1000 * 60));

    // Dnes
    if (diffDays === 0) {
      if (diffHours === 0) {
        if (diffMinutes < 1) {
          return 'Práve teraz';
        }
        return `pred ${diffMinutes} ${diffMinutes === 1 ? 'minútou' : diffMinutes < 5 ? 'minútami' : 'minútami'}`;
      }
      return `pred ${diffHours} ${diffHours === 1 ? 'hodinou' : diffHours < 5 ? 'hodinami' : 'hodinami'}`;
    }

    // Včera
    if (diffDays === 1) {
      return 'Včera';
    }

    // Tento týždeň
    if (diffDays < 7) {
      return `pred ${diffDays} ${diffDays === 1 ? 'dňom' : diffDays < 5 ? 'dňami' : 'dňami'}`;
    }

    // Tento mesiac
    if (diffDays < 30) {
      const weeks = Math.floor(diffDays / 7);
      return `pred ${weeks} ${weeks === 1 ? 'týždňom' : weeks < 5 ? 'týždňami' : 'týždňami'}`;
    }

    // Staršie - formátovaný dátum
    return date.toLocaleDateString('sk-SK', {
      day: 'numeric',
      month: 'short',
      year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined
    });
  } catch (error) {
    // Ak dátum nie je platný, vrátiť pôvodný string
    return dateString;
  }
}

export function formatMemberSince(dateString?: string | Date | number): string {
  if (!dateString) return '-';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('sk-SK', {
      month: 'long',
      year: 'numeric'
    });
  } catch (error) {
    return String(dateString);
  }
}

export function formatDemandDate(dateString: string): string {
  if (!dateString) return '';
  try {
    const date = new Date(dateString);
    if (dateString.includes('T')) {
      return date.toLocaleString('sk-SK', {
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
    return date.toLocaleDateString('sk-SK');
  } catch (error) {
    return dateString;
  }
}

/**
 * Formátuje dátum a čas odpovede na dopyt: d. m. rrrr o HH:mm (napr. 20. 10. 2026 o 19:05)
 */
export function formatResponseDateTime(isoString: string): string {
  try {
    const d = new Date(isoString);
    if (isNaN(d.getTime())) return isoString;
    const day = d.getDate();
    const month = d.getMonth() + 1;
    const year = d.getFullYear();
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    return `${day}. ${month}. ${year} o ${hours}:${minutes}`;
  } catch {
    return isoString;
  }
}

